import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { client } from '../api/client'
import { Parent } from '../types'

interface AuthState {
  token: string | null
  parent: Parent | null
  isAuthenticated: boolean
  setToken: (token: string | null) => void
  setParent: (parent: Parent | null) => void
  updateParent: (parent: Parent) => void
  logout: () => Promise<void>
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      parent: null,
      isAuthenticated: false,
      setToken: (token) =>
        set((state) => ({
          ...state,
          token,
          isAuthenticated: !!token,
        })),
      setParent: (parent) =>
        set((state) => ({
          ...state,
          parent,
        })),
      updateParent: (parent) =>
        set((state) => ({
          ...state,
          parent: {
            ...state.parent,
            ...parent,
          },
        })),
      logout: async () => {
        try {
          // Call the server's logout endpoint
          if (useAuthStore.getState().token) {
            await client.post('/auth/logout/')
          }
        } catch (error) {
          // If the server call fails, we still want to clear the local state
          console.error('Error during logout:', error)
        } finally {
          // Clear the auth state regardless of server response
          set({
            token: null,
            parent: null,
            isAuthenticated: false,
          })
        }
      },
    }),
    {
      name: 'auth-storage',
    }
  )
) 